import AuthHeading from "components/v2/Auth/AuthHeading";
import useResetPassword from "api/UserResource/useResetPassword";
import { ButtonLoader } from "components";
import FormField from "components/v2/Auth/AuthField";
import { Form, Formik } from "formik";
import { useUrlQuery } from "hooks/useUrlQuery";
import AuthLayout from "layouts/AuthLayout";
import * as Yup from "yup";

const ResetPassword = () => {
	let query = useUrlQuery();

	const initialValues = {
		email: query?.get("email") || "",
		password: "",
		password_confirmation: "",
	};

	const validate = Yup.object().shape({
		email: Yup.string().required("Email is required"),
		password: Yup.string()
			.min(6, "At least 6 characters required")
			.matches(/[A-Z]/, "Must have at least one uppercase letter")
			.matches(/[a-z]/, "Must have at least one lowercase letter")
			.matches(/[0-9]/, "Must have at least one digit")
			.required("Password required"),
		password_confirmation: Yup.string()
			.oneOf([Yup.ref("password")], "Passwords didn't match")
			.required("Confirmation required"),
	});

	const { mutateAsync, isLoading } = useResetPassword();
	const handleSubmit = async (data) => {
		await mutateAsync({
			...data,
			token: query?.get("token"),
		});
	};

	return (
		<AuthLayout>
			<AuthHeading heading="A fresh start" subheading="Choose a new password to get back to your library." />

			<Formik
				initialValues={initialValues}
				validationSchema={validate}
				onSubmit={(data) => handleSubmit(data)}
			>
				{() => {
					return (
						<Form className="auth-recovery" noValidate>
							<FormField name="email" type="email" label="Email address*" placeholder="you@example.com" />

							<FormField name="password" type="password" label="New Password*" />

							<FormField
								name="password_confirmation"
								type="password"
								label="Confirm New Password*"
							/>

							<div>
								<button
									type="submit"
									className="auth-primary"
									disabled={isLoading}
								>
									{isLoading ? (
										<>
											Resetting...
											<ButtonLoader
												size={25}
												color="rgba(255, 255, 255)"
											/>{" "}
										</>
									) : (
										"Save new password"
									)}
								</button>
							</div>
						</Form>
					);
				}}
			</Formik>
		</AuthLayout>
	);
};

export default ResetPassword;
